<div class="input" *ngIf="Utility.mobile" (click)="openPopup()">
  <ng-container *ngIf="value">{{value}}</ng-container>
  <span class="f-medium-gray" *ngIf="!value">{{placeholder}}</span>
</div>
<div class="{{Utility.mobile ? 'white-bg z-infinit fixed-fill d-flex flex-column': ''}}"
  *ngIf="!Utility.mobile || popup">
  <div class="d-flex">
    <div class="d-flex align-items-center pointer" (click)="closePopup()" *ngIf="popup">
      <i class="fa fa-arrow-right f-dark-blue fs-xl mr-2"></i>
    </div>
    <div class="flex-fill auto-complete-selector {{popup?'no-border no-shadow': ''}}" [class.search-icon]="searchIcon">
      <ng-select #selector [items]="items$ | async" [inputAttrs]="{maxlength:maxLength,type:'search'}"
        [attr.autofocus]="popup?'autofocus':undefined" [required]="required ? 'required' : undefined"
        [disabled]="disabled" [placeholder]="placeholder" [notFoundText]="notFoundText"
        [typeToSearchText]="typeToSearchText" [typeahead]="searchInput$" [class.no-scroll]="maxSuggest <= 10"
        [appendTo]="popupSelector" [minTermLength]="0" [editableSearchTerm]="true" [clearOnBackspace]="false"
        [clearable]="clearIcon" [bindValue]="'term'" [bindLabel]="'term'" [(ngModel)]="value"
        (keydown.enter)="enter()">
        <ng-template ng-option-tmp let-item="item">
          <div (click)="enter(item)">
            <div class="d-flex align-items-center" *ngIf="item.type=='search'">
              <div class="d-flex flex-grow-1">
                <span class="fs-sm ml-1 d-flex align-items-center">
                  <i class="fa fa-search ml-1"></i>{{createItemText}}&nbsp;
                </span>
                <span [innerHTML]="Utility.highlightSearch(item.term, value, 'em')"></span>
                <span class="fs-sm mr-1"> ...</span>
              </div>
            </div>
            <div class="d-flex align-items-center" *ngIf="item.type != 'search'">
              <div class="d-flex flex-grow-1">
                <span [innerHTML]="Utility.highlightSearch(item.term, value, 'em')"></span>
              </div>
              <i class="fa fa-arrow-up f-medium-gray rotate-45" (click)="setTerm(item.term, $event)"></i>
            </div>
          </div>
        </ng-template>
      </ng-select>
      <i class="fa fa-search pl-2 fs-lg abs-middle left-0" *ngIf="searchIcon"></i>
    </div>
  </div>
  <div [id]="popupId" class="ng-dropdown-panel-container" [class.d-none]="!popup"></div>
</div>